import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'DEPOT_PASS_FUT_DOC',
  title: 'Comment déposer un document passé ou à venir ?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Depuis l’onglet « Documents » '
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Cliquez sur le document de votre choix'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Cliquez sur le bouton « Ajouter une nouvelle version »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_DEPOT_PASS_FUT_DOC/FR_DEPOT_PASS_FUT_DOC.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Procédez ensuite au dépôt de votre document'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Si le document déposé est un document passé, après traitement par nos équipes, il vient s’ajouter à vos archives.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Si c’est un document à venir, il vient compléter ou remplacer votre document « en cours » dès le début de sa validité.'
  }]
};
